(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('SettingsController', SettingsController);

    SettingsController.$inject = ['Principal', '$state', '$uibModal', 'Auth', 'JhiLanguageService', '$translate', 'User', 'AlertService'];

    function SettingsController(Principal, $state, $uibModal, Auth, JhiLanguageService, $translate, User, AlertService) {
        let vm = this;
        vm.error = null;
        vm.settingsAccount = null;
        vm.success = null;

        /**
         * Store the "settings account" in a separate variable, and not in the shared "account" variable.
         */
        vm.copyAccount = function (account) {
            return {
                activated: account.activated,
                email: account.email,
                firstName: account.firstName,
                langKey: account.langKey,
                lastName: account.lastName,
                login: account.login
            };
        };

        vm.copyNotification = function (account) {
            return account.notification;
        };

        function onSuccessCheck(response) {
            vm.updateCheck = {};
            vm.updateCheck.check1 = response.check1;
            vm.updateCheck.check2 = response.check2;
            vm.updateCheck.check3 = response.check3;
        }

        function onErrorCheck(error) {
            console.log(error);
        }

        vm.init = function () {
            Principal.identity().then(function (account) {
                vm.settingsAccount = vm.copyAccount(account);
                vm.settingsNotification = vm.copyNotification(account);
            });
            User.getTerms({}, onSuccessCheck, onErrorCheck);
        }

        vm.save = function () {
            Auth.updateAccount(vm.settingsAccount).then(function () {
                vm.error = null;
                vm.success = 'OK';
                Principal.identity(true).then(function (account) {
                    vm.settingsAccount = vm.copyAccount(account);
                });
                JhiLanguageService.getCurrent().then(function (current) {
                    if (vm.settingsAccount.langKey !== current) {
                        $translate.use(vm.settingsAccount.langKey);
                    }
                });
                User.setTerms(vm.updateCheck);
                User.updateNotifications({
                    login: vm.settingsAccount.login,
                    notification: vm.settingsNotification
                }, onSuccessNot, onErrorNot);
            }).catch(function () {
                vm.success = null;
                vm.error = 'ERROR';
            });
        }

        // new delete function to show confirmation popup
        vm.delete = function () {
            $uibModal.open({
                // new html file contain the popup message
                templateUrl: 'app/account/settings/settings-delete.html',
                controller: 'DeleteController',
                controllerAs: 'vm',
                size: 'md'
            });
        };
        // cancel function to exit the popup
        vm.cancel = function () {
            $state.go('settings', null, {reload: false});
        };

        function onSuccessNot() {
           return true;
        }

        function onErrorNot() {
            vm.success = null;
            vm.error = 'ERROR';
        }

        //open modal to confirm or dismiss change from TOTP to email
        vm.get2FOTP = function () {
            if (vm.settingsNotification.twoFactorEmail) {
                let modalPromise = $uibModal.open({
                    templateUrl: 'app/account/settings/delete-2F.html',
                    controller: 'DeleteTwoFactorController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        pagingParams: ['$stateParams', function () {
                            return {
                                twoFactorEmail: vm.settingsNotification.twoFactorEmail
                            };
                        }]
                    }
                });
                modalPromise.result
                    .then(function (result) {
                        console.log("Modal closed with result", result);
                    }).catch(function (reason) {
                    vm.switchValues();
                });
            }
            User.getTerms({}, onSuccessCheck, onErrorCheck);
        }

        // invert values of email and OTP switches
        vm.switchValues = function () {
            vm.settingsNotification.twoFactorEmail = !vm.settingsNotification.twoFactorEmail;
        }

        //open one of the two modals, depending on current values
        vm.onChange2F = function () {
            vm.switchValues();
            if (vm.settingsNotification.twoFactorEmail) {
                vm.get2FOTP();
            } else {
                User.getTOTP({twoFactorEmail: vm.settingsNotification.twoFactorEmail}, onSuccess2F, onErrorNot);
            }
        }

        // open modal with QR code and auth key
         function onSuccess2F(response) {
            if (!vm.settingsNotification.twoFactorEmail) {
                let modalPromise2F = $uibModal.open({
                    templateUrl: 'app/account/settings/settings-2F-detail.html',
                    controller: 'TwoFactorController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        pagingParams: ['$stateParams', function () {
                            return {
                                result: response
                            };
                        }]
                    }
                });
                modalPromise2F.result
                    .then(function (result) {
                        console.log("Modal closed with result", result);
                    }).catch(function (reason) {
                    vm.switchValues();
                });
            }
        }

        vm.showQrCode = function () {
            User.getTOTP({twoFactorEmail: vm.settingsNotification.twoFactorEmail}, onSuccess2F, onErrorNot);
        }

    }
})();
